(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltGtpCpeMgrController', OltGtpCpeMgrController);

    OltGtpCpeMgrController.$inject = ['$scope', '$uibModalInstance', '$state', 'OltService', 'GtpService', 'oltId', 'showMessage', 'OnuService'];

    function OltGtpCpeMgrController($scope, $uibModalInstance, $state, OltService, GtpService, oltId, showMessage, OnuService) {
        var vm = this;
        vm.requestRunning = false;
        vm.listGtps = [];
        vm.gtpNameSelected = null;
        vm.isInvalid = false;

        if (!showMessage) {
            vm.showMessage = false;
        } else {
            vm.showMessage = showMessage;
        }

        // methods
        vm.setGtp = setGtp;
        vm.save = save;
        vm.close = close;

        vm.dataGtpCpeMgr = {
            id: oltId,
            gtpCpeMgrId: ''
        };

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        // Api
        function save() {
            if (vm.formAddGtp.$valid && !vm.requestRunning) {
                vm.requestRunning = true;

                if (vm.gtp.id) {
                    vm.dataGtpCpeMgr.gtpCpeMgrId = vm.gtp.id;
                } else {
                    vm.dataGtpCpeMgr.gtpCpeMgrId = null;
                }
                OltService.setGtpCpeMgrId(vm.dataGtpCpeMgr).then(successSave).catch(errorSave);
            }
        }

        function getOltData() {
            OltService.getOlt(oltId).then(successGetOlt).catch(errorGetOlt);
        }

        function getGptList() {
            var data = {
                oltId: oltId
            };
            GtpService.listGtp(data).then(successGetGtp).catch(errorGetGtp);
        }

        // Helpers
        function findDataGtpCurrent(gtpId) {
            vm.listGtps.forEach(function (gtp) {
                if (gtp.id == gtpId) {
                    vm.gtp = gtp;
                }
            });
        }

        function setGtp(gtp) {
            vm.gtp = gtp;
        }

        // Requests
        function successGetOlt(data) {
            vm.requestRunning = false;
            vm.dataGtpCpeMgr.gtpCpeMgrId = data.gtpCpeMgrId;
            getGptList();
        }

        function errorGetOlt(response) {
            vm.requestRunning = false;
            OltService.errorModalConstructor(response, 'get');
            vm.close();
        }

        function successGetGtp(data) {
            vm.requestRunning = false;
            vm.listGtps = data;
            if ($state.current.name == 'olt') {
                var gtpEmpty = {
                    name: ''
                };
                vm.listGtps.splice(0, 0, gtpEmpty);
            }
            findDataGtpCurrent(vm.dataGtpCpeMgr.gtpCpeMgrId);
        }

        function errorGetGtp(response) {
            vm.requestRunning = false;
            GtpService.errorModalConstructor(response, 'getOltList');
            vm.close();
        }

        function successSave(data) {
            vm.requestRunning = false;
            var modalInstance = OltService.successModalConstructor('gtpCpeMgr', null, true);
            modalInstance.closed.then(function (data) {
                $uibModalInstance.close();
            });
            deleteAllCpeMgr();
        }

        function deleteAllCpeMgr() {
            OnuService.deleteAllCpeMgr(oltId);
        }

        function errorSave(response) {
            vm.requestRunning = false;
            OltService.errorModalConstructor(response, 'gtpCpeMgr');
        }

        initialize();
        function initialize() {
            getOltData();
        }

    }
})();
